import { UserListPage } from "@pages/UserListPage/UserListPage";

function UserMasterListPage() {
  return <UserListPage />;
}

export { UserMasterListPage };
